import React from 'react'
import { Trans } from '@lingui/macro'

import { AggregatedResultBar } from './AggregatedResultBar'
import './AggregatedResults.less'

export interface IAggregatedItem {
  label: string | boolean
  count: number
  value: number | null // Value is generated for RATING questions before exporting CSV file
}

interface IProps {
  items: IAggregatedItem[]
  total?: number
  avg?: number | null
  median?: number | null
}

const AggregatedResult = ({ items, total, avg, median }: IProps) => {
  const totalCount = items.reduce((acc, option) => {
    return acc + option.count
  }, 0)

  const maxValue = items.reduce(function (prev, current) {
    return prev.count > current.count ? prev : current
  })

  return (
    <div className="AggregatedResult">
      <div className="AggregatedResult__list">
        {items.map((option, index) => (
          <div
            className="AggregatedResult__item"
            key={`${option.label}-${index}`}
          >
            <div className="AggregatedResult__label">{option.label}</div>
            <AggregatedResultBar
              totalCount={totalCount}
              maxValue={maxValue.count}
              optionCount={option.count}
            />
          </div>
        ))}
      </div>
      <div className="AggregatedResult__resume">
        {total && (
          <span>
            <Trans>Responses</Trans>: <strong>{total}</strong>
          </span>
        )}

        {avg && (
          <span>
            <Trans>Mean/Avg</Trans>: <strong>{avg}</strong>
          </span>
        )}

        {median && (
          <span>
            <Trans>Median</Trans>: <strong>{median}</strong>
          </span>
        )}
      </div>
    </div>
  )
}

export default AggregatedResult
